import React from 'react';

import MicIcon from '../../../icons/MicIcon';
import MicOffIcon from '../../../icons/MicOffIcon';

import useLocalAudioToggle from '../../../hooks/useLocalAudioToggle/useLocalAudioToggle';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import { IconButton } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

export default function RoomToggleAudioButton(props: { disabled?: boolean; className?: string }) {
  const [isAudioEnabled, toggleAudioEnabled] = useLocalAudioToggle();
  const { localTracks } = useVideoContext();
  const hasAudioTrack = localTracks.some(track => track.kind === 'audio');

  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;

  return (
    <IconButton
      style={{ width: '48px', height: '48px', border: `solid 1px ${primaryColor}` }}
      className={props.className}
      onClick={toggleAudioEnabled}
      disabled={!hasAudioTrack || props.disabled}
      data-cy-audio-toggle
    >
      {isAudioEnabled ? <MicIcon color={primaryColor} /> : <MicOffIcon color={primaryColor} />}
    </IconButton>
  );
}
